import { render } from "./FreeSub.vue?vue&type=template&id=b219e55c&scoped=true"
import script from "./FreeSub.vue?vue&type=script&lang=js"
export * from "./FreeSub.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b219e55c"]])

export default __exports__